import * as actionTypes from '../../constants/actionTypes';
import { mapAccount } from '../../meta/types/account';
import { ThunkDispatch } from '../../meta/types/actions';
import { StoreState } from '../../meta/types/store';
import { DomainAccountWithDomain } from '../../meta/types/user';
import AccountResource from '../../services/Identity/AccountResource';
import DomainResource from '../../services/Identity/DomainResource';

export interface ISetAccounts {
  type: actionTypes.SET_ACCOUNTS;
  accounts: DomainAccountWithDomain[];
}

export const setAccounts = (accounts: DomainAccountWithDomain[]): ISetAccounts => ({
  type: actionTypes.SET_ACCOUNTS,
  accounts,
});

export interface ISetAccountsFetching {
  type: actionTypes.SET_ACCOUNTS_FETCHING;
  fetching: boolean;
}

export const setAccountsFetching = (fetching: boolean): ISetAccountsFetching => ({
  type: actionTypes.SET_ACCOUNTS_FETCHING,
  fetching,
});

export const fetchAccounts = () => {
  return async (
    dispatch: ThunkDispatch,
    getState: () => StoreState,
  ): Promise<DomainAccountWithDomain[]> => {
    const accountsState = getState().account;

    if (accountsState.fetched) {
      return accountsState.accounts;
    }

    const userId = getState().auth.configurableUser!.id;

    dispatch(setAccountsFetching(true));
    const resp = await AccountResource.list({ userId });
    const accounts = resp.member.map(mapAccount);
    const accountsWithDomains = await Promise.all(
      accounts.map(async acc => {
        const domain = await DomainResource.get({ domainId: acc.domainId });
        return { ...acc, domain };
      }),
    );
    dispatch(setAccounts(accountsWithDomains));
    return Promise.resolve(accountsWithDomains);
  };
};
